import { render } from "./GestaoView.vue?vue&type=template&id=d54e80c6&scoped=true"
import script from "./GestaoView.vue?vue&type=script&lang=js"
export * from "./GestaoView.vue?vue&type=script&lang=js"

import "./GestaoView.vue?vue&type=style&index=0&id=d54e80c6&lang=scss&scoped=true"

import exportComponent from "/home/ctis-desenvolvimento/Projetos/front-end/piso-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d54e80c6"]])

export default __exports__